import { Select, SelectCreatable, TextInput } from 'Components/Form'
import { checkLabel } from 'Utils/helper'

export default function InputParameters({ data, datas, name, setFieldValue, className, valueJSON, errors }) {
    if (['0', '1', '4'].includes(data?.data_type?.toString())) {
        var type = 'text'
        switch (data?.data_type?.toString()) {
            case '1':
                type = 'number'
                break
            case '4':
                type = 'date'
                break
            default:
                type = 'text'
                break
        }
        return (
            <TextInput
                id={`${name}${data?.id}`}
                name={`${name}${data?.id}`}
                label={data?.name}
                type={type}
                value={datas?.details?.[data?.id] ?? ''}
                className={className}
                onChange={e => setFieldValue(`${name}${data?.id}`, e.target.value)}
                error={errors?.[data?.id]}
            />
        )
    } else if (data?.data_type?.toString() === '2') {
        return (
            <Select
                id={`${name}${data?.id}`}
                name={`${name}${data?.id}`}
                label={data?.name}
                placeholder={data?.name}
                className={className}
                value={datas?.details?.[data?.id] ?? ''}
                options={data?.options?.map(e => ({
                    id: checkLabel(e, valueJSON),
                    label: checkLabel(e, valueJSON),
                }))}
                onChange={e => setFieldValue(`${name}${data?.id}`, e.target.value)}
                error={errors?.[data?.id]}
            />
        )
    } else if (data?.data_type?.toString() === '3') {
        return (
            <SelectCreatable
                id={`${name}${data?.id}`}
                name={`${name}${data?.id}`}
                className={className}
                label={data?.name}
                placeholder={data?.name}
                value={(datas?.details?.[data?.id] ?? []).map(e => ({
                    value: e,
                    label: e,
                }))}
                options={data?.options?.map(e => ({
                    value: checkLabel(e, valueJSON),
                    label: checkLabel(e, valueJSON),
                }))}
                onChange={e =>
                    setFieldValue(
                        `${name}${data?.id}`,
                        e.map(f => f.value)
                    )
                }
                error={errors?.[data?.id]}
                isMulti
                isCreatable
            />
        )
    }
    return null
}
